import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "center"
}
const _hoisted_2 = {
  key: 1,
  class: "center"
}

import { onMounted, ref } from "vue";
import ProgressCircular from "../Commons/ProgressCircular.vue";
import { useAuth } from "@/composables/useAuth";
import {
  getInscripcionesEquipoByUser,
  getInscripcionesIndividualByUser,
} from "@/services/InscripcionesService";
import {
  InscripcionUsuarioEquipoDTO,
  InscripcionUsuarioIndividualDTO,
} from "@/interfaces/Inscripcion";
import TablaInscripcionesTorneoEquipo from "../Inscripcion/TablaInscripcionesTorneoEquipo.vue";
import TablaInscripcionesTorneoIndividual from "../Inscripcion/TablaInscripcionesTorneoIndividual.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CardInscripcionesUsuarioTorneo',
  setup(__props) {

const isLoading = ref<boolean>(false);
const { getidUsuario } = useAuth();
const idUsuarioLogger = ref<string>(getidUsuario.value || "");
const inscripcionesIndividual = ref<InscripcionUsuarioIndividualDTO[]>();
const inscripcionesEquipo = ref<InscripcionUsuarioEquipoDTO[]>();
const tab = ref("sin-disputar");

const idUsuario = ref<number>(parseInt(idUsuarioLogger.value));

onMounted(async () => {
  if (idUsuarioLogger.value) {
    try {
      isLoading.value = true;
      const responseIndividual = await getInscripcionesIndividualByUser(
        idUsuarioLogger.value
      );
      inscripcionesIndividual.value = responseIndividual.data;

      const responseEquipo = await getInscripcionesEquipoByUser(
        parseInt(idUsuarioLogger.value)
      );
      inscripcionesEquipo.value = responseEquipo.data;
    } catch (error) {
      console.error(
        "Error al obtener las inscripciones de un torneo de un usuario: ",
        error
      );
    } finally {
      isLoading.value = false;
    }
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_tabs_window_item = _resolveComponent("v-tabs-window-item")!
  const _component_v_tabs_window = _resolveComponent("v-tabs-window")!
  const _component_v_card = _resolveComponent("v-card")!

  return (isLoading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(ProgressCircular)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createVNode(_component_v_card, { class: "mb-0 pl-4 pr-4 text-center" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "ringbearer" }, {
              default: _withCtx(() => [
                _createTextVNode("Mis inscripciones")
              ]),
              _: 1
            }),
            _createVNode(_component_v_divider, { class: "mt-3" }),
            _createVNode(_component_v_tabs, {
              modelValue: tab.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tab).value = $event)),
              "background-color": "primary",
              dark: "",
              grow: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_tab, { value: "sin-disputar" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Sin disputar")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_tab, { value: "disputados" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Disputados")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_v_tabs_window, {
              modelValue: tab.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((tab).value = $event))
            }, {
              default: _withCtx(() => [
                (tab.value === 'sin-disputar')
                  ? (_openBlock(), _createBlock(_component_v_tabs_window_item, {
                      key: 0,
                      value: "sin-disputar"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card_text, null, {
                          default: _withCtx(() => [
                            _createVNode(TablaInscripcionesTorneoIndividual, {
                              isLoading: isLoading.value,
                              listaTorneos: 
                (inscripcionesIndividual.value ?? []).filter(
                  (torneo) =>
                    new Date(torneo.torneo.fechaFinTorneo) >= new Date()
                )
              ,
                              idUsuario: idUsuario.value,
                              disputado: false
                            }, null, 8, ["isLoading", "listaTorneos", "idUsuario"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_card_text, null, {
                          default: _withCtx(() => [
                            _createVNode(TablaInscripcionesTorneoEquipo, {
                              isLoading: isLoading.value,
                              listaTorneos: 
                (inscripcionesEquipo.value ?? []).filter(
                  (torneo) =>
                    new Date(torneo.torneo.fechaFinTorneo) >= new Date()
                )
              ,
                              idUsuario: idUsuario.value,
                              disputado: false
                            }, null, 8, ["isLoading", "listaTorneos", "idUsuario"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (tab.value === 'disputados')
                  ? (_openBlock(), _createBlock(_component_v_tabs_window_item, {
                      key: 1,
                      value: "disputados"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card_text, null, {
                          default: _withCtx(() => [
                            _createVNode(TablaInscripcionesTorneoIndividual, {
                              isLoading: isLoading.value,
                              listaTorneos: 
                (inscripcionesIndividual.value ?? []).filter(
                  (torneo) =>
                    new Date(torneo.torneo.fechaFinTorneo) < new Date()
                )
              ,
                              idUsuario: idUsuario.value,
                              disputado: true
                            }, null, 8, ["isLoading", "listaTorneos", "idUsuario"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_card_text, null, {
                          default: _withCtx(() => [
                            _createVNode(TablaInscripcionesTorneoEquipo, {
                              isLoading: isLoading.value,
                              listaTorneos: 
                (inscripcionesEquipo.value ?? []).filter(
                  (torneo) =>
                    new Date(torneo.torneo.fechaFinTorneo) < new Date()
                )
              ,
                              idUsuario: idUsuario.value,
                              disputado: true
                            }, null, 8, ["isLoading", "listaTorneos", "idUsuario"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]))
}
}

})